import { componentProvider } from 'js-component-framework/es';
import ModalDialog from '@/js/ModalDialog';
import breakpoints from '@/js/utils/breakpoints';

/**
 * Manage the button for opening the mobile search filters.
 *
 * @param {HTMLElement} args.element The mobile filter button.
 * @param {object}      args.options The ModalDialog options.
 */
function searchFilterButton({ element, options }) {
  let menuButton = null;

  /**
   * Manage ModalDialog instance across breakpoints.
   */
  const handleBreakpoint = () => {
    if (breakpoints.lgMin.matches) {
      if (menuButton instanceof ModalDialog) {
        menuButton.destroy();
        menuButton = null;
      }
    } else {
      menuButton = new ModalDialog(element, options);
    }
  };

  handleBreakpoint();
  breakpoints.lgMin.addEventListener('change', handleBreakpoint);
}

const searchFilterConfig = {
  name: 'search-filter-button',
  component: searchFilterButton,
  options: {
    close: '.search-filter__close',
    useTransition: true,
  },
};

componentProvider(searchFilterConfig);
